import { render, staticRenderFns } from "./UplimitPromotion.vue?vue&type=template&id=4d071ae0&scoped=true"
import script from "./UplimitPromotion.vue?vue&type=script&lang=js"
export * from "./UplimitPromotion.vue?vue&type=script&lang=js"
import style0 from "./UplimitPromotion.vue?vue&type=style&index=0&id=4d071ae0&prod&scoped=true&lang=css"
import style1 from "./UplimitPromotion.vue?vue&type=style&index=1&id=4d071ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d071ae0",
  null
  
)

export default component.exports